import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";

import { Doughnut } from "react-chartjs-2";
import {
    Block,
    BlockDes,
    BlockHead,
    Col,
    Row,
    PreviewAltCard,
    Button,
    Icon,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import OptionM from "../../components/DynmicOption/OptionM";
import OptionC from "../../components/DynmicOption/OptionC";
import DGEDashboardCount from "../DynamicComponent/DGEDashboardCount";
import ButtonDisable from "./ButtonDisable";


async function maindatacal(year, month, catgtype, api) {

    const sendData = {
        YearId: Number(year),
        MonthId: Number(month),
        Month: String(catgtype),
    }
    //console.log(sendData)
    await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/' + api, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(sendData)

    })
        .then(response => response.json())
        .then(
            data => {
                //console.log(data)
                if (data.edit + data.submit === 0) {
                    return (<> <td><Button color="primary" >View</Button></td></>)
                }
                else { 
                return <></>
                 }
            })



};

const StateDashboard = ({ ...props }) => {
    const [loading, setLoading] = useState(false);
    const [transData, setTransData] = useState([]);
    const [activedata, setactivedata] = useState([]);
    const [onSearchText, setSearchText] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [modal, setModal] = useState({
        add: false,
    });
    const today = new Date();
    const [lorder, setLorder] = useState(true);
    const [data, setData] = useState(transData);
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 0,
        activeStatus: "",

    });
    const [userData, setuserData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(10);
    const [sort, setSortState] = useState("");
    const [Edit, setEdit] = useState({
        edit: 0,
        submit: 0,
        open: 0
    })
    if (formData.month === 0 && formData.year === 2024) {
        setFormData({ ...formData, year: 2023, month: 12 })
        //console.log("Call")
    }
    const [data2, setData2] = useState({
        labels: ["Deaft", "Submitted", "Open"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                data: [12, 8, 7],
            },
        ],
    })
    const tableRef = useRef(null);
    const getdata = async () => {
        const sendData = {
            CatgTypeId: Number(sessionStorage.getItem("State")),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetRegion', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setactivedata(data)
                    setLorder(false)
                })


    };

    const getdata2 = async () => {
        //console.log(props)

        const sendData = {
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            Month: sessionStorage.getItem("State")
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/Dgecount', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data)
                    setEdit({
                        edit: data.edit,
                        submit: data.submit,
                        open: data.open
                    })
                    setData2({
                        labels: ["Draft", "Submitted", "Open"],
                        dataUnit: "People",
                        legend: false,
                        datasets: [
                            {
                                borderColor: "#fff",
                                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                                data: [data.edit, data.submit, data.open],
                            },
                        ],
                    })
                })


    };

    const usergetdata = async () => {


        const sendData = {
            CatgTypeId: Number(sessionStorage.getItem("State")),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/Getuser2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data)
                    setuserData(data)

                })


    };

    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };

    const sortingFunc = (params) => {
        let defaultData = data;
        if (params === "asc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(a.cloudMcatId) - parseFloat(b.cloudMcatId));
            setData([...sortedData]);
        } else if (params === "dsc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(b.cloudMcatId) - parseFloat(a.cloudMcatId));
            setData([...sortedData]);
        }
    };

    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {

                return item.organizationName.toLowerCase().includes(onSearchText.toLowerCase()) || item.phoneNo.toLowerCase().includes(onSearchText.toLowerCase()) || item.emailId.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);


    useEffect(() => {
        usergetdata()
        getdata()
        getdata2()
        setLorder(true)
    }, [formData.month, formData.year])

    // onChange function for searching name
    const onFilterChange = (e) => {
        setSearchText(e.target.value);
    };

    // function to reset the form
    const resetForm = () => {
        setFormData({
            organization: "",
            desiganationyear: "",
            designation: "",
        });
    };

    // function to close the form modal
    const onFormCancel = () => {
        setModal({ add: false });
        resetForm();
    };


    const onFormSubmit2 = (num) => {

        sessionStorage.setItem('userIdd', num);
        props.history.push("/profile-view")


    }
    const onFormSubmit3 = (num) => {

        sessionStorage.setItem('userIdd', num);
        props.history.push("/profile-edit")


    }

    const viewpage = async (path, employmentId, employmentRefId) => {

        sessionStorage.setItem("employmentId", employmentId)
        sessionStorage.setItem("EmploymentRefId", employmentRefId)
        props.history.push(path)
    };

    const approved = () => {
        Swal.fire({
            title: 'Are You Sure ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Update',
            confirmButtonColor: 'success',
            denyButtonText: `Don't Update`,
        })
    }
    const Userupdate = () => {
        Swal.fire({
            title: 'Are You Sure ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Update',
            confirmButtonColor: 'success',
            denyButtonText: `Don't Update`,
        })
    }

    const onFormSubmit = async (userrole, activestatus) => {

        Swal.fire({
            title: 'Are You Sure ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Update',
            confirmButtonColor: 'success',
            denyButtonText: `Don't Update`,
        }).then(async (result) => {

            /* Read more about isConfirmed, isDenied below */
            let timerInterval
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Updating....',
                    html: 'I will close in <b></b> milliseconds.',
                    timer: 20000,
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading()
                        const b = Swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                            b.textContent = Swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                })
                const sendData = {
                    UserRoleId: userrole,
                    ActiveStatus: activestatus
                }

                await fetch('https://n4nairmatrimonyapi.azurewebsites.net/api/Main/Deactiveuser', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            setLoading(false)
                            onFormCancel()
                            if (data === "Done") {
                                Swal.fire({
                                    icon: "success",
                                    title: "Done",
                                    text: "Profile Updated Successfully",
                                    focusConfirm: false,
                                });
                                getdata()



                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: "Duplicate Entry",
                                    focusConfirm: false,
                                });
                                getdata()
                            }
                        })

            } else if (result.isDenied) {
                getdata()
            }
        })



    };

    // function to load detail data

    // function to toggle the search option


    // Get current list, pagination
    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const { errors, register, handleSubmit } = useForm();

    return (
        <React.Fragment>
            <Head title="AllUser" />

            <Content>
                {localStorage.getItem("urole") !== "8" ?
                    <Button onClick={() => window.location.href ='/DGEDashboard'} style={{ marginBottom: 20 }} color='success'> <Icon name="arrow-left" />  Back To DGE Dashboard</Button> : null}

                <Block>

                    <BlockHead size="lg">

                        <BlockDes className="text-soft">

                            <Row >

                                <Col xl="3" md="3">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>State Dashboard</h5>
                                    </td>
                                </Col> <Col xl="3" md="3">
                                    <td >
                                        <label className="form-label" htmlFor="Month">
                                            State: <label style={{ fontWeight: "bold" }}>  {userData !== null ? userData.catgType : null}</label>
                                        </label>
                                    </td>
                                </Col>
                               {/* <Col xl="2" md="2" >

                                    <label style={{ color: 'black', fontSize: 15 }}>  Region :  <label style={{ fontWeight: 'bold' }}> {userData != null ? userData.state : null}</label>R1</label>
                                </Col>*/}
                                <Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 15 }}>  Year :  <label style={{ fontWeight: 'bold' }}><OptionC onInputChange={onInputChange} namemain="year" mainid="year" /></label></label>


                                </Col>
                               
                            </Row>
                            <hr />
                            <Row>
                                <Col md="4" xxl="4">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The State dashboard shows the data of employment exchange of a particular month

                                        </small></h6>
                                    </PreviewAltCard>
                                </Col>
                                <Col md="8" xxl="8">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <Row>
                                            <Col md="2"></Col>
                                            <Col md="6">
                                                <div className="traffic-channel-group">

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                            <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {Edit.edit}</large> </b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                            <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}>{Edit.submit}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>
                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                                                            <b style={{ fontSize: 20 }}> Open  : <large style={{ marginLeft: 77 }}>{Edit.open}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="traffic-channel-doughnut-ck">
                                                    <Doughnut
                                                        className="analytics-doughnut"
                                                        data={data2}
                                                        options={{
                                                            legend: {
                                                                display: false,
                                                            },
                                                            rotation: -1.5,
                                                            cutoutPercentage: 70,
                                                            maintainAspectRatio: false,
                                                            tooltips: {
                                                                enabled: true,
                                                                backgroundColor: "#fff",
                                                                borderColor: "#eff6ff",
                                                                borderWidth: 2,
                                                                titleFontSize: 13,
                                                                titleFontColor: "#6783b8",
                                                                titleMarginBottom: 6,
                                                                bodyFontColor: "#9eaecf",
                                                                bodyFontSize: 12,
                                                                bodySpacing: 4,
                                                                yPadding: 10,
                                                                xPadding: 10,
                                                                footerMarginTop: 0,
                                                                displayColors: false,
                                                            },
                                                        }}
                                                    ></Doughnut>
                                                </div>

                                            </Col>
                                        </Row>
                                    </PreviewAltCard>

                                </Col>
                            </Row>
                        </BlockDes>


                    </BlockHead>


                    <div className="table-responsive">
                        <table className="table table-orders" ref={tableRef}>
                            <thead className="tb-odr-head">
                                <tr className="tb-odr-item" >

                                    <th >
                                       List

                                    </th>
                                    <th >
                                        No. of EEX

                                    </th>
                                    <th >
                                        Total Forms

                                    </th>
                                    <th >
                                        Open

                                    </th>
                                    <th >
                                        Draft

                                    </th>
                                    <th >
                                        Submited

                                    </th>
                                    <th >
                                        Action

                                    </th>



                                </tr>


                            </thead>
                            {lorder?null:<>
                            {activedata !== [] ? activedata.map((details) =>
                                <tr>

                                    <td> <a href="#id" onClick={() => (sessionStorage.setItem("Region", details.catgTypeId), props.history.push("/Reasonal-Dashboard")) } ><b style={{ fontSize: 18 }}>{details.catgType}</b>
                                    </a></td>
                                    <DGEDashboardCount year={formData.year} month={formData.month} catgtype={details.catgTypeId} api={'Statecount'} />
                                    <ButtonDisable year={formData.year} month={formData.month} catgtype={details.catgTypeId} api={'Statecount'} />
                                 </tr>
                            ) : null}
                            </>}




                        </table>

                    </div>




                </Block>




            </Content>

        </React.Fragment>
    );
};

export default StateDashboard;
